import { render, staticRenderFns } from "./LibraryBookTitle.vue?vue&type=template&id=cb11c308&"
import script from "./LibraryBookTitle.vue?vue&type=script&lang=js&"
export * from "./LibraryBookTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports